import chain from '@/lib/axios-chain'
// 首页不再提醒
export const noNotice = () => chain.create('/user/organize/nevernotify', 'post')

// 合并帐号提交
export const saveBindForm = () => chain.create('/user/organize/bindaccount', 'post')

// 企业微信跳转合并接口
export const merge = () => chain.create('/user/user/bindm', 'post')

// 企业微信跳转合并接口
export const mergeForm = () => chain.create('/user/user/bindm2', 'post')
